import { APPS, loggerConfig } from "@creditas/home-mf-shared";
import { getAppNameByPathname } from "./getAppNameByPathname";

export function initMonitoring() {
  const appKeyName = getAppNameByPathname();
  const service = APPS[appKeyName].appName || null;
  const shouldEnableMonitoring =
    process.env.REACT_APP_ENVIRONMENT_NAME === "production";

  if (!service) return;

  loggerConfig.initMonitoringTool({
    appName: service,
    isEnvAllowed: shouldEnableMonitoring,
  });
}
